import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { Observable } from 'rxjs';
import { CancellationService } from 'src/app/cancellation/services/cancellation.service';
import { KEYWORDS } from 'src/app/core/enums/enums';
import { PenaltyAdditonal } from 'src/app/core/models/cancellation-overrides.model';
import { VoluntaryChangeService } from 'src/app/voluntary-change/services/voluntary-change.service';

@Component({
  selector: 'app-draggable-list',
  templateUrl: './draggable-list.component.html',
  styleUrls: ['./draggable-list.component.scss']
})
export class DraggableListComponent implements OnInit, OnDestroy {
  @Input() type: number;
  @Input() managementtype: string;
  @Input() list: PenaltyAdditonal[];
  @Input() groupName: string = '';
  @Input() set query(value: string) {
    if (value) {
      this.findInSelectedText(value);
    }
  }

  @Output() queryNotFound = new EventEmitter();
  @Output() changeFirst = new EventEmitter<any>();

  public getLoadingPenalties$: Observable<boolean>;

  constructor(
    private dragulaService: DragulaService,
    private service: CancellationService,
    private serviceVoluntary: VoluntaryChangeService
  ) {}

  ngOnInit() {
    if (this.managementtype == 'exangevoluntary') {
      this.getLoadingPenalties$ = this.serviceVoluntary.getLoadingPenalties();
    }

    if (this.managementtype == 'cancellation') {
      this.getLoadingPenalties$ = this.service.getLoadingPenalties();
    }

    this.groupName == '' ? (this.groupName = 'HEAD') : (this.groupName = this.groupName);

    if (this.dragulaService.find(this.groupName)) {
      null;
    } else {
      this.dragulaService.createGroup(this.groupName, {
        moves: (el, container, handle) => handle.className === 'handle'
      });
    }
  }

  findInSelectedText(value: string) {
    let invalid = false;
    !!this.list[0] && !!this.list[0].categories
      ? this.list[0].categories.forEach((category) => {
          const text = category.freeText;
          invalid = this.findInTexts(text, value) ? true : invalid;
          this.queryNotFound.emit(invalid);
        })
      : this.queryNotFound.emit(true);
  }

  listChange() {
    if (this.type == 1) {
      this.changeFirst.emit(this.list[0] || []);
    } else if (this.type == 2) {
      this.changeFirst.emit(this.list[0].fareBasis);
    }
  }

  findInTexts(text: string, value: string) {
    return text.includes(value);
  }

  highlight(categoryText: string) {
    KEYWORDS.forEach((key) => {
      categoryText = categoryText.replace(
        new RegExp(key, 'gi'),
        (match) => '<span class="has-background-yellow"> ' + match + ' </span>'
      );
    });
    return categoryText;
  }

  ngOnDestroy() {
    if (this.dragulaService.find(this.groupName)) {
      this.dragulaService.destroy(this.groupName);
    }
  }
}
